const constant = {
  keepLimit: 1800000,
  notifyShowTime: {
    normal: 5000,
    short: 3000,
    long: 10000
  },
  html: {
    loading: './static/html/loading.html', // 読み込み中HTML
    error: './static/html/error.html?msg=' // エラー表示HTML
  },
  // 5: 人事管理責任者（マイナンバー閲覧・給与情報管理）
  userAuthority: { system_management: 1, application_including: 2, application_not_included: 3, browsing_including: 4, hr_manager: 5 },
  isShopMaster: { sub: 0, boss: 1 },
  officerUserIds: [19761, 16002],
  zeroInfinity: {
    boundaryPrice: 5000,
    sendPrice: 450
  }
}

export default constant



// WEBPACK FOOTER //
// ./src/store/constant.js